import InputType from './InputType';

export default class RaterInputType extends InputType {
  constructor({ key, options = [] }) {
    super({ key });
    this.options = options;
  }
}
